export enum Severity {
    Danger = 0,
    Warning = 1,
    Success = 2,
    Info = 3
}

export interface FlashMessage {
    id: string;
    preface: string;
    severity: Severity;
    text: string;
}
